export const STRINGS = {
  DEHAAT_BUSINESS_APP: 'DeHaat-Business APP',
  DEHAAT_FARMER_APP: 'DeHaat-Farmer APP',
  PAGE_TITLE: 'DeHaat | Farm Intelligence',
  PAGE_DESCRIPTION:
    'DeHaat connects farmers to suppliers and buyers on a single platform. Online marketplace providing all the agricultural products and services to farmers.',
  PAGE_HEADING: 'Farm Intelligence',
  SUB_HEADING: 'AI, ML & Analytics',
  DESCRIPTION:
    "Quantity, quality and availability of farm produce are important factors that drive major part of India's economy. It has a direct impact on livelihood of the farmers as well as operations of downstream food production companies.\n\nUsing Data Science, Agri Science and Machine Learning technologies, we have been working on Artificial Intelligence engine that can correlate many of parameters that affect agriculture and provide predictive analytics and early warning solutions for better production and prediction.",
  BENEFITS: 'Benefits',
  PERSONALIZED_ADVISORY_FOR_FARMERS: 'Personalized advisory for farmer',
  AI_POWERED_ADVISORY:
    'AI-powered advisory based on the crop, agro-climactic conditions and specific farming conditions of the farmer.',
  EARLY_WARNING: 'Early-warning for crop protection',
  PROVIDE_WARNINGS:
    'Provide warnings of inclement weather and pestilence ahead of time and possible preventive actions and remedies.',
  BETTER_RISK_MANAGEMENT: 'Better risk management for Insurance',
  PROVIDE_RISK_MANAGEMENT:
    'Provide risk assessment and monitoring services to Insurance companies for better insurance service management.',
}

export const appList = [
  {
    icon: '/assets/images/farmer',
    alt: STRINGS.DEHAAT_FARMER_APP,
    appName: STRINGS.DEHAAT_FARMER_APP,
    appLink:
      'https://play.google.com/store/apps/details?id=app.intspvt.com.farmer',
  },
  {
    icon: '/assets/images/business-app',
    alt: STRINGS.DEHAAT_BUSINESS_APP,
    appName: STRINGS.DEHAAT_BUSINESS_APP,
    appLink:
      'https://play.google.com/store/apps/details?id=com.intspvt.app.dehaat2',
  },
]

export const featureList = [
  {
    image: '/assets/images/farm-intelligence/analysis',
    imageAlt: STRINGS.PERSONALIZED_ADVISORY_FOR_FARMERS,
    title: STRINGS.PERSONALIZED_ADVISORY_FOR_FARMERS,
    description: STRINGS.AI_POWERED_ADVISORY,
    key: 'personalized_advisory',
  },
  {
    image: '/assets/images/farm-intelligence/browser',
    imageAlt: STRINGS.EARLY_WARNING,
    title: STRINGS.EARLY_WARNING,
    description: STRINGS.PROVIDE_WARNINGS,
    key: 'early-warning',
  },
  {
    image: '/assets/images/farm-intelligence/brain',
    imageAlt: STRINGS.BETTER_RISK_MANAGEMENT,
    title: STRINGS.BETTER_RISK_MANAGEMENT,
    description: STRINGS.PROVIDE_RISK_MANAGEMENT,
    key: 'better_risk_management',
  },
]
